
namespace Gamification.Gamification {

    @Serenity.Decorators.registerClass()
    export class DispositiviGrid extends Serenity.EntityGrid<DispositiviRow, any> {
        protected getColumnsKey() { return DispositiviColumns.columnsKey; }
        protected getDialogType() { return DispositiviDialog; }
        protected getIdProperty() { return DispositiviRow.idProperty; }
        protected getInsertPermission() { return DispositiviRow.insertPermission; }
        protected getLocalTextPrefix() { return DispositiviRow.localTextPrefix; }
        protected getService() { return DispositiviService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}